<template>
<span class="kb_breadcrumb__item">
    <span
      :class="['kb_breadcrumb__inner', to ? 'is-link' : '']"
      ref="link"
      role="link"
    >
      <slot></slot>
    </span>
    <!-- <i
      v-if="separatorClass"
      class="kb_breadcrumb__separator"
      :class="separatorClass"
    ></i> -->
    <span
      v-if="!isLastItem"
      class="kb_breadcrumb__separator"
      role="presentation"
      >{{ separator }}</span
    >
  </span>
</template>

<script>
export default {
  name: "BreadCrumbItem",
  props: {
    to: {},
    replace: Boolean,
    isLastItem: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      separator: "",
      separatorClass: "",
    };
  },

  inject: ["elBreadcrumb"],

  mounted() {
    this.separator = this.elBreadcrumb.separator;
    this.separatorClass = this.elBreadcrumb.separatorClass;
    const link = this.$refs.link;
    link.setAttribute("role", "link");
    link.addEventListener("click", (_) => {
      const { to, $router } = this;
      if (!to || !$router) return;
      this.replace ? $router.replace(to) : $router.push(to);
    });
  },
};
</script>

<style lang="scss" scoped>
.kb_breadcrumb__separator {
  margin: 0 6px;
  font-weight: bold;
  color: #c0c4cc;

  &[class*="icon"] {
    margin: 0 6px;
    font-weight: normal;
  }
}

.kb_breadcrumb__item {
  float: left;
  white-space: nowrap;
  .kb_breadcrumb__inner {
    display: inline;
  }

  &:last-child {
    .kb_breadcrumb__inner,
    .kb_breadcrumb__inner a {
      &,
      &:hover {
        font-weight: normal;
        /* color: #606266; */
        /* cursor: text; */
      }
    }

    .kb_breadcrumb__separator {
      display: none;
    }
  }
}
</style>
